import { render, staticRenderFns } from "./FooterSmall.vue?vue&type=template&id=173aabcc&"
import script from "./FooterSmall.vue?vue&type=script&lang=js&"
export * from "./FooterSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports